import Swiper, { Navigation } from 'swiper'

const Testimonials = () => {
  const swiper = new Swiper('.testimonials-slider', {
    modules: [Navigation],
    slidesPerView: 1,
    autoHeight: true,
    navigation: {
      nextEl: '.testimonials-navigation .slider-button-next',
      prevEl: '.testimonials-navigation .slider-button-prev',
    },
  })

  var slides = document.querySelectorAll('.testimonials-slider .testimonial');
  
  if (slides.length == 1) {
    document.querySelector("[data-component='testimonials']").classList.add("one-slide");
  }
}

export default Testimonials
